// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activitiesSportsPage {
  width: 100%;
  min-height: 100%;
  margin-top: 0 !important;
  padding: 0 0 32px;
  background: transparent;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}

.activitiesSportsPageHeader {
  display: flex;
  width: calc(100% + 48px);
  min-height: 70px;
  align-items: stretch;
  gap: 28px;
  margin: -20px 0 18px -24px;
  padding: 0 72px 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.activitiesSportsPageHeader__title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.activitiesSportsPageHeader h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.activitiesSportsPageHeader__title > span,
.activitiesSportsTabs button span,
.activitiesSportsButton__badge {
  display: inline-flex;
  min-width: 22px;
  height: 20px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11px;
  font-weight: 800;
}

.activitiesSportsPageHeader__title > span {
  min-width: 24px;
  height: 22px;
  padding: 0 8px;
  font-size: 11.5px;
}

.activitiesSportsTabs {
  display: flex;
  min-width: 0;
  align-items: stretch;
  gap: 4px;
}

.activitiesSportsTabs button {
  position: relative;
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  padding: 2px 14px 0;
  border: 0;
  background: transparent;
  color: var(--text-muted, #64748b);
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}

.activitiesSportsTabs button::after {
  position: absolute;
  right: 12px;
  bottom: -1px;
  left: 12px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: transparent;
  content: '';
}

.activitiesSportsTabs button:hover,
.activitiesSportsTabs button.is-active {
  color: var(--text-strong, #0f172a);
}

.activitiesSportsTabs button.is-active {
  font-weight: 800;
}

.activitiesSportsTabs button.is-active::after {
  background: var(--action-primary, #227ebd);
}

.activitiesSportsShell {
  width: 100%;
  max-width: none;
}

.activitiesSportsListCard {
  position: relative;
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.activitiesSportsIcon {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
}

.activitiesSportsListToolbar {
  display: flex;
  min-height: 64px;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px 12px 0 0;
  background: var(--surface-card, #fff);
}

.activitiesSportsSearch {
  display: inline-flex;
  width: min(420px, 100%);
  height: 38px;
  align-items: center;
  gap: 9px;
  margin: 0;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-subtle, #94a3b8);
  flex: 0 1 420px;
}

.activitiesSportsSearch:focus-within {
  border-color: var(--action-primary, #227ebd);
  box-shadow: 0 0 0 3px var(--brand-100, #d6e7f6);
}

.activitiesSportsSearch input {
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-strong, #0f172a);
  font: inherit;
  font-size: 13px;
}

.activitiesSportsSearch > button {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.activitiesSportsButton {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 13px;
  border: 1px solid transparent;
  border-radius: var(--radius-md, 8px);
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.14s ease, border-color 0.14s ease, color 0.14s ease;
}

.activitiesSportsButton:disabled {
  opacity: 0.55;
  cursor: default;
}

.activitiesSportsButton .activitiesSportsIcon {
  width: 16px;
  height: 16px;
}

.activitiesSportsListToolbar .activitiesSportsButton {
  height: 38px;
  min-height: 38px;
}

.activitiesSportsButton--primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.activitiesSportsButton--primary:hover:not(:disabled) {
  border-color: var(--blue-700, #155d8c);
  background: var(--blue-700, #155d8c);
}

.activitiesSportsButton--secondary {
  border-color: var(--border-default, #cbd5e1);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
}

.activitiesSportsButton--secondary:hover:not(:disabled),
.activitiesSportsButton--secondary.is-active {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.activitiesSportsButton--secondary.is-active .activitiesSportsButton__badge {
  background: var(--surface-card, #fff);
}

.activitiesSportsButton--ghost {
  border-color: transparent;
  background: transparent;
  color: var(--blue-700, #155d8c);
}

.activitiesSportsButton--ghost:hover:not(:disabled) {
  background: var(--blue-50, #eef6fc);
}

.activitiesSportsColumns {
  position: relative;
}

.activitiesSportsColumnsMenu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  width: 270px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--surface-card, #fff);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.16);
}

.activitiesSportsColumnsMenu header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 8px 9px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  color: var(--text-strong, #0f172a);
  font-size: 12px;
}

.activitiesSportsColumnsMenu header button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue-700, #155d8c);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.activitiesSportsColumnsMenu label {
  display: flex;
  min-height: 38px;
  align-items: center;
  gap: 9px;
  margin: 0;
  padding: 0 8px;
  border-radius: 7px;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.activitiesSportsColumnsMenu label:hover {
  background: var(--surface-sunken, #f1f5f9);
}

.activitiesSportsColumnsMenu label.is-locked {
  color: var(--text-muted, #64748b);
  cursor: default;
}

.activitiesSportsColumnsMenu label input,
.activitiesSportsTable input[type='checkbox'] {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--action-primary, #227ebd);
}

.activitiesSportsColumnsMenu label small {
  margin-left: auto;
  color: var(--text-subtle, #94a3b8);
  font-size: 10px;
  font-weight: 700;
}

.activitiesSportsActiveFilters {
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.activitiesSportsActiveFilters > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  padding: 0 9px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 12px;
}

.activitiesSportsActiveFilters > span b {
  font-weight: 800;
}

.activitiesSportsActiveFilters button {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: 800;
  cursor: pointer;
}

.activitiesSportsActiveFilters > span button {
  margin-left: 3px;
  font-size: 16px;
  line-height: 1;
}

.activitiesSportsActiveFilters > button {
  margin-left: 2px;
  color: var(--blue-700, #155d8c);
  font-size: 12px;
}

.activitiesSportsSelectionBar {
  display: flex;
  min-height: 48px;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border-top: 1px solid var(--blue-100, #d4e8f6);
  border-bottom: 1px solid var(--blue-100, #d4e8f6);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 13px;
  font-weight: 600;
}

.activitiesSportsSelectionBar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
}

.activitiesSportsTableScroll {
  width: 100%;
  overflow-x: auto;
}

.activitiesSportsTable {
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
  table-layout: auto;
}

.activitiesSportsTable th {
  height: 44px;
  padding: 0 14px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.045em;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}

.activitiesSportsTable td {
  height: 56px;
  padding: 8px 14px;
  border-bottom: 1px solid var(--border-subtle, #e8edf2);
  color: var(--text-body, #334155);
  font-size: 13px;
  vertical-align: middle;
}

.activitiesSportsTable tbody tr:hover,
.activitiesSportsTable tbody tr.is-selected {
  background: var(--blue-50, #eef6fc);
}

.activitiesSportsSelectCell {
  width: 46px;
  padding-right: 6px !important;
  text-align: center !important;
}

.activitiesSportsNameCell {
  display: flex;
  min-width: 280px;
  align-items: center;
  gap: 11px;
}

.activitiesSportsNameCell > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.activitiesSportsNameCell strong {
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-size: 13.5px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activitiesSportsNameCell small {
  display: block;
  max-width: 430px;
  overflow: hidden;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activitiesSportsTile {
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  overflow: hidden;
  border-radius: 8px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.activitiesSportsTile .activitiesSportsIcon {
  width: 20px;
  height: 20px;
}

.activitiesSportsTile--image {
  border: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.activitiesSportsTile--image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.activitiesSportsFormat,
.activitiesSportsDetails span {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-body, #334155);
  font-size: 10.5px;
  font-weight: 750;
  white-space: nowrap;
}

.activitiesSportsDetails {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.activitiesSportsDetails span {
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.activitiesSportsDetails em {
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
  font-style: normal;
}

.activitiesSportsUpdated {
  color: var(--text-muted, #64748b) !important;
  white-space: nowrap;
}

.activitiesSportsFavouriteHead,
.activitiesSportsFavouriteCell {
  width: 92px;
  text-align: center !important;
}

.activitiesSportsStar {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: var(--text-subtle, #94a3b8);
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.activitiesSportsStar:hover:not(:disabled) {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
  color: #c88600;
}

.activitiesSportsStar.is-active {
  border-color: var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}

.activitiesSportsStar:disabled {
  opacity: 0.55;
  cursor: default;
}

.activitiesSportsStar .activitiesSportsIcon {
  width: 18px;
  height: 18px;
}

.activitiesSportsTable__empty {
  height: 230px !important;
  color: var(--text-muted, #64748b) !important;
  text-align: center;
}

.activitiesSportsTable__empty > div {
  display: flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  border-radius: 10px;
  background: var(--blue-50, #eef6fc);
  color: var(--action-primary, #227ebd);
}

.activitiesSportsTable__empty strong,
.activitiesSportsTable__empty span {
  display: block;
}

.activitiesSportsTable__empty strong {
  margin-bottom: 4px;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
}

.activitiesSportsTable__empty span {
  font-size: 12.5px;
}

.activitiesSportsPagination {
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 0 0 11px 11px;
  background: var(--surface-card, #fff);
}

.activitiesSportsPagination > span {
  margin-right: auto;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 650;
}

.activitiesSportsPagination button {
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.activitiesSportsPagination button:hover:not(:disabled),
.activitiesSportsPagination button.is-active {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.activitiesSportsPagination button:disabled {
  opacity: 0.45;
  cursor: default;
}

.activitiesSportsFilterOverlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  justify-content: flex-end;
  background: rgba(15, 23, 42, 0.24);
}

.activitiesSportsFilterDrawer {
  display: flex;
  width: min(440px, calc(100vw - 32px));
  height: 100vh;
  flex-direction: column;
  border-left: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}

.activitiesSportsFilterDrawer > header {
  display: flex;
  min-height: 76px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 22px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.activitiesSportsFilterDrawer > header h2 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, inherit);
  font-size: 22px;
  font-weight: 800;
}

.activitiesSportsFilterDrawer > header button {
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-muted, #64748b);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.activitiesSportsFilterDrawer__body {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 22px;
  overflow-y: auto;
  padding: 20px 22px 28px;
}

.activitiesSportsFilterDrawer__body .people-chipFilter + .people-chipFilter {
  padding-top: 18px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.activitiesSportsFilterDrawer__body .people-chipFilter__body {
  max-height: none;
  overflow: visible;
}

.activitiesSportsFilterDrawer > footer {
  display: flex;
  min-height: 66px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}

.activitiesSportsFilterDrawer > footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.activitiesSportsLoadError {
  display: flex;
  min-height: 330px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  text-align: center;
}

.activitiesSportsLoadError > div {
  display: flex;
  width: 52px;
  height: 52px;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
  border-radius: 13px;
  background: #fdeef0;
  color: #a7283b;
}

.activitiesSportsLoadError h2 {
  margin: 0 0 6px;
  color: var(--text-strong, #0f172a);
  font-size: 18px;
  font-weight: 800;
}

.activitiesSportsLoadError p {
  max-width: 480px;
  margin: 0 0 18px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

.activitiesSportsToast {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1080;
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  gap: 9px;
  padding: 10px 15px;
  border-radius: 9px;
  background: var(--brand-navy, #164170);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.22);
}

.activitiesSportsToast--error {
  background: #9f2638;
}

@media (max-width: 1217px) {
  .activitiesSportsPageHeader {
    width: 100vw;
    margin-left: -12px;
    padding-right: 28px;
  }
}

@media (max-width: 760px) {
  .activitiesSportsPage {
    padding-bottom: 24px;
  }

  .activitiesSportsPageHeader {
    min-height: 106px;
    flex-direction: column;
    gap: 0;
    margin-bottom: 14px;
    padding: 12px 16px 0;
  }

  .activitiesSportsPageHeader__title {
    min-height: 46px;
  }

  .activitiesSportsTabs {
    min-height: 48px;
    overflow-x: auto;
  }

  .activitiesSportsListToolbar {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .activitiesSportsSearch {
    width: 100%;
    flex: 1 0 100%;
  }

  .activitiesSportsColumns {
    flex: 1 1 auto;
  }

  .activitiesSportsColumns > .activitiesSportsButton,
  .activitiesSportsListToolbar > .activitiesSportsButton {
    width: 100%;
  }

  .activitiesSportsColumnsMenu {
    right: 0;
  }

  .activitiesSportsSelectionBar {
    align-items: stretch;
    flex-direction: column;
  }

  .activitiesSportsSelectionBar__actions {
    width: 100%;
    margin-left: 0;
  }

  .activitiesSportsSelectionBar__actions .activitiesSportsButton {
    flex: 1 1 auto;
  }

  .activitiesSportsPagination {
    flex-wrap: wrap;
  }

  .activitiesSportsPagination > span {
    width: 100%;
    margin: 0 0 4px;
  }

  .activitiesSportsFilterDrawer {
    width: 100vw;
  }

  .activitiesSportsFilterDrawer > footer {
    align-items: stretch;
    flex-direction: column;
  }

  .activitiesSportsFilterDrawer > footer > div,
  .activitiesSportsFilterDrawer > footer .activitiesSportsButton {
    width: 100%;
  }

  .activitiesSportsFilterDrawer > footer > div .activitiesSportsButton {
    flex: 1 1 0;
  }

  .activitiesSportsToast {
    right: 14px;
    bottom: 14px;
    left: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/AdminConsole/Sports/Sports.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,8FAA8F;AAChG;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,0BAA0B;EAC1B,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;;EAGE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sDAAsD;EACtD,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;EAEE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,sDAAsD;EACtD,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,8CAA8C;EAC9C,iDAAiD;EACjD,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sDAAsD;EACtD,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sDAAsD;EACtD,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,oDAAoD;EACpD,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+CAA+C;EAC/C,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,MAAM;IACN,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF","sourcesContent":[".activitiesSportsPage {\n  width: 100%;\n  min-height: 100%;\n  margin-top: 0 !important;\n  padding: 0 0 32px;\n  background: transparent;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n\n.activitiesSportsPageHeader {\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 70px;\n  align-items: stretch;\n  gap: 28px;\n  margin: -20px 0 18px -24px;\n  padding: 0 72px 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.activitiesSportsPageHeader__title {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n  flex: 0 0 auto;\n}\n\n.activitiesSportsPageHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.015em;\n  white-space: nowrap;\n}\n\n.activitiesSportsPageHeader__title > span,\n.activitiesSportsTabs button span,\n.activitiesSportsButton__badge {\n  display: inline-flex;\n  min-width: 22px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.activitiesSportsPageHeader__title > span {\n  min-width: 24px;\n  height: 22px;\n  padding: 0 8px;\n  font-size: 11.5px;\n}\n\n.activitiesSportsTabs {\n  display: flex;\n  min-width: 0;\n  align-items: stretch;\n  gap: 4px;\n}\n\n.activitiesSportsTabs button {\n  position: relative;\n  display: inline-flex;\n  min-width: 0;\n  align-items: center;\n  gap: 7px;\n  padding: 2px 14px 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.activitiesSportsTabs button::after {\n  position: absolute;\n  right: 12px;\n  bottom: -1px;\n  left: 12px;\n  height: 3px;\n  border-radius: 3px 3px 0 0;\n  background: transparent;\n  content: '';\n}\n\n.activitiesSportsTabs button:hover,\n.activitiesSportsTabs button.is-active {\n  color: var(--text-strong, #0f172a);\n}\n\n.activitiesSportsTabs button.is-active {\n  font-weight: 800;\n}\n\n.activitiesSportsTabs button.is-active::after {\n  background: var(--action-primary, #227ebd);\n}\n\n.activitiesSportsShell {\n  width: 100%;\n  max-width: none;\n}\n\n.activitiesSportsListCard {\n  position: relative;\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.activitiesSportsIcon {\n  width: 17px;\n  height: 17px;\n  flex: 0 0 auto;\n}\n\n.activitiesSportsListToolbar {\n  display: flex;\n  min-height: 64px;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px 12px 0 0;\n  background: var(--surface-card, #fff);\n}\n\n.activitiesSportsSearch {\n  display: inline-flex;\n  width: min(420px, 100%);\n  height: 38px;\n  align-items: center;\n  gap: 9px;\n  margin: 0;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-subtle, #94a3b8);\n  flex: 0 1 420px;\n}\n\n.activitiesSportsSearch:focus-within {\n  border-color: var(--action-primary, #227ebd);\n  box-shadow: 0 0 0 3px var(--brand-100, #d6e7f6);\n}\n\n.activitiesSportsSearch input {\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n  font-size: 13px;\n}\n\n.activitiesSportsSearch > button {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.activitiesSportsButton {\n  display: inline-flex;\n  min-height: 36px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 13px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md, 8px);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  transition: background-color 0.14s ease, border-color 0.14s ease, color 0.14s ease;\n}\n\n.activitiesSportsButton:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.activitiesSportsButton .activitiesSportsIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.activitiesSportsListToolbar .activitiesSportsButton {\n  height: 38px;\n  min-height: 38px;\n}\n\n.activitiesSportsButton--primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.activitiesSportsButton--primary:hover:not(:disabled) {\n  border-color: var(--blue-700, #155d8c);\n  background: var(--blue-700, #155d8c);\n}\n\n.activitiesSportsButton--secondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n}\n\n.activitiesSportsButton--secondary:hover:not(:disabled),\n.activitiesSportsButton--secondary.is-active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.activitiesSportsButton--secondary.is-active .activitiesSportsButton__badge {\n  background: var(--surface-card, #fff);\n}\n\n.activitiesSportsButton--ghost {\n  border-color: transparent;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n}\n\n.activitiesSportsButton--ghost:hover:not(:disabled) {\n  background: var(--blue-50, #eef6fc);\n}\n\n.activitiesSportsColumns {\n  position: relative;\n}\n\n.activitiesSportsColumnsMenu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 30;\n  width: 270px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.16);\n}\n\n.activitiesSportsColumnsMenu header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 7px 8px 9px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  color: var(--text-strong, #0f172a);\n  font-size: 12px;\n}\n\n.activitiesSportsColumnsMenu header button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.activitiesSportsColumnsMenu label {\n  display: flex;\n  min-height: 38px;\n  align-items: center;\n  gap: 9px;\n  margin: 0;\n  padding: 0 8px;\n  border-radius: 7px;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.activitiesSportsColumnsMenu label:hover {\n  background: var(--surface-sunken, #f1f5f9);\n}\n\n.activitiesSportsColumnsMenu label.is-locked {\n  color: var(--text-muted, #64748b);\n  cursor: default;\n}\n\n.activitiesSportsColumnsMenu label input,\n.activitiesSportsTable input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.activitiesSportsColumnsMenu label small {\n  margin-left: auto;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.activitiesSportsActiveFilters {\n  display: flex;\n  min-height: 44px;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.activitiesSportsActiveFilters > span {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 4px;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n}\n\n.activitiesSportsActiveFilters > span b {\n  font-weight: 800;\n}\n\n.activitiesSportsActiveFilters button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.activitiesSportsActiveFilters > span button {\n  margin-left: 3px;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.activitiesSportsActiveFilters > button {\n  margin-left: 2px;\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n}\n\n.activitiesSportsSelectionBar {\n  display: flex;\n  min-height: 48px;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 16px;\n  border-top: 1px solid var(--blue-100, #d4e8f6);\n  border-bottom: 1px solid var(--blue-100, #d4e8f6);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.activitiesSportsSelectionBar__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  flex-wrap: wrap;\n}\n\n.activitiesSportsTableScroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.activitiesSportsTable {\n  width: 100%;\n  min-width: 860px;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.activitiesSportsTable th {\n  height: 44px;\n  padding: 0 14px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.045em;\n  text-align: left;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.activitiesSportsTable td {\n  height: 56px;\n  padding: 8px 14px;\n  border-bottom: 1px solid var(--border-subtle, #e8edf2);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.activitiesSportsTable tbody tr:hover,\n.activitiesSportsTable tbody tr.is-selected {\n  background: var(--blue-50, #eef6fc);\n}\n\n.activitiesSportsSelectCell {\n  width: 46px;\n  padding-right: 6px !important;\n  text-align: center !important;\n}\n\n.activitiesSportsNameCell {\n  display: flex;\n  min-width: 280px;\n  align-items: center;\n  gap: 11px;\n}\n\n.activitiesSportsNameCell > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.activitiesSportsNameCell strong {\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-size: 13.5px;\n  font-weight: 800;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.activitiesSportsNameCell small {\n  display: block;\n  max-width: 430px;\n  overflow: hidden;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.activitiesSportsTile {\n  display: inline-flex;\n  width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  overflow: hidden;\n  border-radius: 8px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.activitiesSportsTile .activitiesSportsIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.activitiesSportsTile--image {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.activitiesSportsTile--image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.activitiesSportsFormat,\n.activitiesSportsDetails span {\n  display: inline-flex;\n  min-height: 22px;\n  align-items: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-size: 10.5px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.activitiesSportsDetails {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n\n.activitiesSportsDetails span {\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.activitiesSportsDetails em {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n  font-style: normal;\n}\n\n.activitiesSportsUpdated {\n  color: var(--text-muted, #64748b) !important;\n  white-space: nowrap;\n}\n\n.activitiesSportsFavouriteHead,\n.activitiesSportsFavouriteCell {\n  width: 92px;\n  text-align: center !important;\n}\n\n.activitiesSportsStar {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-subtle, #94a3b8);\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.activitiesSportsStar:hover:not(:disabled) {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n  color: #c88600;\n}\n\n.activitiesSportsStar.is-active {\n  border-color: var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n\n.activitiesSportsStar:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.activitiesSportsStar .activitiesSportsIcon {\n  width: 18px;\n  height: 18px;\n}\n\n.activitiesSportsTable__empty {\n  height: 230px !important;\n  color: var(--text-muted, #64748b) !important;\n  text-align: center;\n}\n\n.activitiesSportsTable__empty > div {\n  display: flex;\n  width: 42px;\n  height: 42px;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 10px;\n  border-radius: 10px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--action-primary, #227ebd);\n}\n\n.activitiesSportsTable__empty strong,\n.activitiesSportsTable__empty span {\n  display: block;\n}\n\n.activitiesSportsTable__empty strong {\n  margin-bottom: 4px;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n}\n\n.activitiesSportsTable__empty span {\n  font-size: 12.5px;\n}\n\n.activitiesSportsPagination {\n  display: flex;\n  min-height: 58px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  padding: 10px 16px;\n  border-radius: 0 0 11px 11px;\n  background: var(--surface-card, #fff);\n}\n\n.activitiesSportsPagination > span {\n  margin-right: auto;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.activitiesSportsPagination button {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.activitiesSportsPagination button:hover:not(:disabled),\n.activitiesSportsPagination button.is-active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.activitiesSportsPagination button:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.activitiesSportsFilterOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  justify-content: flex-end;\n  background: rgba(15, 23, 42, 0.24);\n}\n\n.activitiesSportsFilterDrawer {\n  display: flex;\n  width: min(440px, calc(100vw - 32px));\n  height: 100vh;\n  flex-direction: column;\n  border-left: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.activitiesSportsFilterDrawer > header {\n  display: flex;\n  min-height: 76px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 18px 22px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.activitiesSportsFilterDrawer > header h2 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, inherit);\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.activitiesSportsFilterDrawer > header button {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #64748b);\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.activitiesSportsFilterDrawer__body {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 22px;\n  overflow-y: auto;\n  padding: 20px 22px 28px;\n}\n\n.activitiesSportsFilterDrawer__body .people-chipFilter + .people-chipFilter {\n  padding-top: 18px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.activitiesSportsFilterDrawer__body .people-chipFilter__body {\n  max-height: none;\n  overflow: visible;\n}\n\n.activitiesSportsFilterDrawer > footer {\n  display: flex;\n  min-height: 66px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n\n.activitiesSportsFilterDrawer > footer > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.activitiesSportsLoadError {\n  display: flex;\n  min-height: 330px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  text-align: center;\n}\n\n.activitiesSportsLoadError > div {\n  display: flex;\n  width: 52px;\n  height: 52px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 13px;\n  border-radius: 13px;\n  background: #fdeef0;\n  color: #a7283b;\n}\n\n.activitiesSportsLoadError h2 {\n  margin: 0 0 6px;\n  color: var(--text-strong, #0f172a);\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.activitiesSportsLoadError p {\n  max-width: 480px;\n  margin: 0 0 18px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n.activitiesSportsToast {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  z-index: 1080;\n  display: inline-flex;\n  min-height: 44px;\n  align-items: center;\n  gap: 9px;\n  padding: 10px 15px;\n  border-radius: 9px;\n  background: var(--brand-navy, #164170);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.22);\n}\n\n.activitiesSportsToast--error {\n  background: #9f2638;\n}\n\n@media (max-width: 1217px) {\n  .activitiesSportsPageHeader {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n\n@media (max-width: 760px) {\n  .activitiesSportsPage {\n    padding-bottom: 24px;\n  }\n\n  .activitiesSportsPageHeader {\n    min-height: 106px;\n    flex-direction: column;\n    gap: 0;\n    margin-bottom: 14px;\n    padding: 12px 16px 0;\n  }\n\n  .activitiesSportsPageHeader__title {\n    min-height: 46px;\n  }\n\n  .activitiesSportsTabs {\n    min-height: 48px;\n    overflow-x: auto;\n  }\n\n  .activitiesSportsListToolbar {\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n\n  .activitiesSportsSearch {\n    width: 100%;\n    flex: 1 0 100%;\n  }\n\n  .activitiesSportsColumns {\n    flex: 1 1 auto;\n  }\n\n  .activitiesSportsColumns > .activitiesSportsButton,\n  .activitiesSportsListToolbar > .activitiesSportsButton {\n    width: 100%;\n  }\n\n  .activitiesSportsColumnsMenu {\n    right: 0;\n  }\n\n  .activitiesSportsSelectionBar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .activitiesSportsSelectionBar__actions {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .activitiesSportsSelectionBar__actions .activitiesSportsButton {\n    flex: 1 1 auto;\n  }\n\n  .activitiesSportsPagination {\n    flex-wrap: wrap;\n  }\n\n  .activitiesSportsPagination > span {\n    width: 100%;\n    margin: 0 0 4px;\n  }\n\n  .activitiesSportsFilterDrawer {\n    width: 100vw;\n  }\n\n  .activitiesSportsFilterDrawer > footer {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .activitiesSportsFilterDrawer > footer > div,\n  .activitiesSportsFilterDrawer > footer .activitiesSportsButton {\n    width: 100%;\n  }\n\n  .activitiesSportsFilterDrawer > footer > div .activitiesSportsButton {\n    flex: 1 1 0;\n  }\n\n  .activitiesSportsToast {\n    right: 14px;\n    bottom: 14px;\n    left: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
